"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledTextareaContainer = exports.StyledTextarea = exports.StyledTextAreaRoot = void 0;
var _styles = require("../styles");
var _styledComponents = require("../input/styled-components");
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

const StyledTextAreaRoot = exports.StyledTextAreaRoot = (0, _styles.styled)('div', props => {
  return {
    ...(0, _styledComponents.getRootStyles)({
      $positive: false,
      ...props,
      $hasIconTrailing: false
    }),
    width: props.$resize ? 'fit-content' : '100%'
  };
});
StyledTextAreaRoot.displayName = "StyledTextAreaRoot";
StyledTextAreaRoot.displayName = 'StyledTextAreaRoot';
const StyledTextareaContainer = exports.StyledTextareaContainer = (0, _styles.styled)('div', props => {
  return (0, _styledComponents.getInputContainerStyles)({
    $positive: false,
    ...props
  });
});
StyledTextareaContainer.displayName = "StyledTextareaContainer";
StyledTextareaContainer.displayName = 'StyledTextareaContainer';
const StyledTextarea = exports.StyledTextarea = (0, _styles.styled)('textarea', props => {
  return {
    ...(0, _styledComponents.getInputStyles)(props),
    resize: props.$resize || 'none'
  };
});
StyledTextarea.displayName = "StyledTextarea";
StyledTextarea.displayName = 'StyledTextarea';